// @wc-ignore-file
// Pure data module: the locale codes below are storage values compared with
// `===`, not UI copy. wuchale extracts string literals from plain .ts files
// too, so without this directive "en"/"fr"/"de" would be machine-translated
// and the lookup would silently stop matching under a non-English locale.

import { LOCALE_KEY } from "@/lib/local-storage.consts";
import { type Locale, de, enUS, fr } from "date-fns/locale";
import { useLocalStorage } from "usehooks-ts";

/** The date-fns locale for each app locale; anything else falls back to en-US. */
const DATE_FNS_LOCALES: Record<string, Locale> = { en: enUS, fr, de };

/** Maps a stored app locale code to its date-fns locale (en-US by default). */
export function dateFnsLocale(appLocale: string | null | undefined): Locale {
  // hasOwn, not a bare lookup: a stored value of "constructor" or "toString"
  // would otherwise resolve to a prototype member and be returned as a locale.
  return appLocale && Object.hasOwn(DATE_FNS_LOCALES, appLocale)
    ? DATE_FNS_LOCALES[appLocale]
    : enUS;
}

/**
 * The date-fns locale matching the app's language, for `formatDistanceToNow`
 * and friends — date-fns defaults to English when no locale is passed, which
 * left relative times untranslated (CR-101; CR-99 history dialog).
 */
export function useDateFnsLocale(): Locale {
  const [appLocale] = useLocalStorage<string>(LOCALE_KEY, "en");
  return dateFnsLocale(appLocale);
}
